var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 6,
    viewBox: "0 0 8 6",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.54704 0.235285C4.40534 0.085115 4.20801 0 4.00154 0C3.79507 0 3.59774 0.085115 3.45604 0.235285L0.704503 3.15139C0.420234 3.45266 0.434017 3.92733 0.735287 4.2116C1.03656 4.49587 1.51123 4.48209 1.7955 4.18082L3.92881 1.91992C3.96828 1.87809 4.03481 1.87809 4.07428 1.91992L6.20758 4.18082C6.49185 4.48209 6.96653 4.49587 7.2678 4.2116C7.56907 3.92733 7.58285 3.45266 7.29858 3.15139L4.54704 0.235285Z",
    fill: "#60636B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrow);
export default __webpack_public_path__ + "static/media/up-arrow.8641d2475c2ca3db3d6bcbbd75c9e1d9.svg";
export { ForwardRef as ReactComponent };